import React from 'react'
import cardOne from './Images/rowThree/cardSeven.jpg'
import cardTwo from './Images/rowThree/cardEight.jpg'
import cardThree from './Images/rowThree/cardNight.jpg'
export default function FeaturedWork() {
    return (
        <div className='py-5' style={{backgroundColor:'#6C6D71'}}>
        
            <h1 style={{ color: "white",fontWeight:'bold'}} className="text-center mb-5">Featured Works</h1>
            
                  <div >
          
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"#6C6D71",borderRadius:'0px',color:'white'}} class="card">
                           <div style={{backgroundColor:"#6C6D71",padding:'10px',color:"white",borderRadius:'0px',fontWeight:'bold'}} className="card-header d-flex justify-content-center">
                            <h4 className="text-center" style={{fontWeight:'bold'}}>THE LANGHAM HOTEL </h4>
                           </div>
                            <img style={{height:'230px'}} src={cardOne} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#6C6D71'}} class="card-body">
                        

                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"#6C6D71",borderRadius:'0px',color:'white'}} class="card">
                        <div style={{backgroundColor:"#6C6D71",padding:'10px',color:"white",borderRadius:'0px',fontWeight:'bold'}} className="card-header d-flex justify-content-center">
                            <h4 className="text-center" style={{fontWeight:'bold'}}>FRENCH QUARTER INN</h4>
                           </div>
                            <img style={{height:'230px'}} src={cardTwo} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#6C6D71'}} class="card-body">
                       
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div style={{borderColor:"#6C6D71",borderRadius:'0px',color:'white'}} class="card">
                        <div style={{backgroundColor:"#6C6D71",padding:'10px',color:"white",borderRadius:'0px',fontWeight:'bold'}} className="card-header d-flex justify-content-center">
                            <h4 className="text-center" style={{fontWeight:'bold'}}>INSIDE RENOVATION </h4>
                           </div>
                            <img style={{height:'230px'}} src={cardThree} class="card-img-top" alt="..." />
                            <div style={{backgroundColor:'#6C6D71'}} class="card-body">
                  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/services copy 3.jsx